webpackJsonp([12836020992764],{

/***/ 341:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"frontmatter":{"title":"UX for Lean Startups","path":"/blog/libros/ux-for-lean-startups"}}}]}},"pathContext":{"tag":"ux"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-etiquetas-ux-0dfe74b08e3a95867a38.js